import { Modal, SaveBar, TitleBar, useAppBridge } from '@shopify/app-bridge-react';
import { useEffect, useState } from 'react';

const ModalAMPCustomize = ({
  handleModalCustomizeState,
  handleModalCustomizeData,
}) => {

  // Shopify 属性
  const shopify = useAppBridge();

  const [editState, setEditState] = useState(false); // 是否可以操作
  const [barState, setBarState] = useState(false);   // 是否显示了保存bar

  // 关闭弹窗
  const modalHideAction = async () => {
    handleModalCustomizeState(false, "/speedOpt/seo-ant-amp", "AMP_Customize_Modal");  // 回退指定页面
  }

  // 舍弃保存
  const handleDiscard = () => {
    if (editState) {
      shopify.saveBar.hide('SaveBarMax_AMP');
      handleModalCustomizeData('discard', "AMP_Customize_Modal");
      setBarState(false);
    }
  };

  // 内容保存
  const handleSave = () => {
    if (editState) {
      handleModalCustomizeData('save', "AMP_Customize_Modal");
    }
  }

  // 接收子窗口
  const handleFromModalCustomize = (ev) => {
    const _that = ev.data;
    if (_that?.page === "Edit") {
      const _type = _that?.mode || '';
      if (_type === "save") {
        // 保存
        shopify.saveBar.hide('SaveBarMax_AMP');
        setBarState(false);
      } else if (_type === "showSavebar") {
        // 显示保存bar
        setEditState(true);
        // 判断是否显示了
        if (!barState) {
          shopify.saveBar.show("SaveBarMax_AMP");
          setBarState(true);
        }
      } else if (_type === "hideSavebar") {
        shopify.saveBar.hide("SaveBarMax_AMP");
        setBarState(false);
      } else { }
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleFromModalCustomize)
    return () => {
      window.removeEventListener('message', handleFromModalCustomize)
    }
  }, [])

  // 弹窗模块
  return (
    <Modal id="AMP_Customize_Modal" src={"/speedOpt/seo-ant-amp/custome"} variant={"max"} onHide={modalHideAction}>
      <TitleBar title={"SEOAnt - AMP Settings"} />
      <SaveBar id="SaveBarMax_AMP" discardConfirmation="">
        <button onClick={handleDiscard}></button>
        <button variant="primary" onClick={handleSave}></button>
      </SaveBar>
    </Modal>
  )

}

export default ModalAMPCustomize;